<template>
  <v-menu
    :close-on-content-click="false"
    rounded="lg"
    :value="isOpened"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="n-white-btn n-small-btn n-icon-btn primary--text"
        v-on="on"
        @click="isOpened = true"
      >
        <v-icon style="font-size: 20px;">tune</v-icon>
      </v-btn>
    </template>
    <n-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <div class="font-weight-bold">Paramètres de la liste d'interventions</div>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn
              icon
              @click="isOpened = false"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-subheader>Ordre des interventions</v-subheader>
        <v-list-item
          v-for="sort in sorts"
          :key="sort.id"
          @click="currentSort = sort"
        >
          <v-list-item-icon class="mt-3 mb-3">
            <v-icon
              color="primary darken-2"
              v-if="currentSort.id === sort.id"
            >
              check
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            {{ sort.label }}
          </v-list-item-content>
        </v-list-item>
        <v-subheader>Nombre d'interventions par page</v-subheader>
        <v-list-item
          v-for="(nbItemsPerPageOption, i) in nbItemsPerPageOptions"
          :key="`nbItemsPerPageOption-${i}`"
          @click="currentNbItemsPerPage = nbItemsPerPageOption"
        >
          <v-list-item-icon class="mt-3 mb-3">
            <v-icon
              color="primary darken-2"
              v-if="currentNbItemsPerPage === nbItemsPerPageOption"
            >
              check
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            {{ nbItemsPerPageOption }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </n-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';

const NB_ITEMS_PAR_PAGE_OPTIONS = [5, 10, 20, 50, 100];

export default {
  data: () => ({
    isOpened: true,
    nbItemsPerPageOptions: NB_ITEMS_PAR_PAGE_OPTIONS,
  }),

  computed: {
    ...mapState(`ui/interventions`, [
      `sorts`,
      `sortId`,
    ]),
    currentSort: {
      get() { return this.$store.getters[`ui/interventions/currentSort`]; },
      set(sort) { this.$store.commit(`ui/interventions/SET_SORT_ID`, sort.id); },
    },
    currentNbItemsPerPage: {
      get() { return this.$store.getters[`ui/interventions/currentNbItemsPerPage`]; },
      set(nbItemsPerPage) { this.$store.commit(`ui/interventions/SET_NB_ITEMS_PER_PAGE`, nbItemsPerPage); },
    },
  },

  beforeMount() {
    this.isOpened = false;
  },
};
</script>

<style lang="scss">
</style>
